/**
 * Шкала заполненности. Доля приходит с бэкенда готовым процентом.
 *
 * Общий компонент, а не третья копия разметки: заполняемых полос в приложении
 * уже две — `RiskMeter` (уровень риска) и `RobotIncomeRow` (доля результата), —
 * и каждая нарисована на месте. Четвёртая была бы перебором, а эта нужна сразу
 * в трёх местах: карточка каталога, экран робота и подсказка на вводе суммы.
 *
 * `RiskMeter` сюда НЕ переезжает намеренно: у него `role="meter"` — это
 * измеренная величина, а не прогресс задачи, и подменять роль ради общей
 * разметки значило бы соврать скринридеру.
 *
 * Ширина ставится из строки как есть. Считать долю здесь нельзя: `value` — это
 * деньги в процентах, а арифметика над деньгами живёт только в `shared/lib/money.ts`
 * (гард качества это проверяет). Бэкенд отдаёт `fill_pct` уже обрезанным сотней
 * и округлённым вниз.
 */
export type ProgressTone = "accent" | "warning" | "loss";

const TONES: Record<ProgressTone, string> = {
  accent: "bg-action-primary",
  warning: "bg-status-warning",
  loss: "bg-status-loss",
};

export function ProgressBar({
  valuePct,
  label,
  tone = "accent",
  valueText,
}: {
  /** Процент заполнения строкой, «69.00». Приходит с бэкенда посчитанным. */
  valuePct: string;
  /** Доступное имя шкалы: без него это безымянный прямоугольник. */
  label: string;
  tone?: ProgressTone;
  /** Человеческая подпись для скринридера: «18 630 из 27 000 USDT». */
  valueText?: string;
}) {
  return (
    <div
      className="h-1.5 w-full overflow-hidden rounded-full bg-background-raised"
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Number(valuePct)}
      aria-valuetext={valueText}
    >
      <div
        className={`animate-meter-fill h-full rounded-full ${TONES[tone]}`}
        style={{ width: `${valuePct}%` }}
      />
    </div>
  );
}
